// src/constants/reports.ts
export const REPORT_TYPE = {
  FLAT: 'FLAT',
  MULTI_PAGE: 'MULTI_PAGE',
} as const;

export const DEFAULT_REPORT_PROMPT = 'Here\'s the report';

// Slot container animation and styling constants
export const SLOT_ANIMATION = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.3 },
} as const;

export const SLOT_CONTAINER_CLASSES =
  'mt-3 relative rounded-2xl border border-black/10 bg-white overflow-hidden';